import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateDialog } from 'store/dialog/reducer';

const useDialog = () => {
    const result = useSelector((state) => state.dialog.confirmDialog.result);
    const dispatch = useDispatch();
    const resolver = useRef();
    const isShow = useSelector((state) => state.dialog.confirmDialog.isShow);

    useEffect(() => {
        if (result === true || result === false) {
            resolver.current && resolver.current(result);
            if (isShow) {
                dispatch(
                    updateDialog({
                        isShow: false,
                    }),
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result]);

    const handleShow = ({
        title,
        description,
        cancelButtonText,
        confirmButtonText,
        disableCancelButton = false,
        isError = false,
        messages,
        extraTips,
        callback,
    }) => {
        setTimeout(() => {
            dispatch(
                updateDialog({
                    isShow: true,
                    title,
                    description,
                    cancelButtonText,
                    confirmButtonText,
                    disableCancelButton,
                    result: undefined,
                    isError,
                    messages,
                    extraTips,
                    callback,
                }),
            );
        }, 50);

        return new Promise(function (resolve) {
            resolver.current = resolve;
        });
    };

    return handleShow;
};

export default useDialog;
